import {PageUrlInfo, UrlListItem} from '../Models/Types'
import {SignedUpSignboard, SignedUpState} from './SignedUpSignboardDTO'
import {ListUtility} from '../Utils/ListUtility'
import {Optional} from '../../Common/TypeHelper'

export type SignedUpBucketInfoJSON = {
  id: number
  bucketKey: string
  bucketName: string
  urlList: UrlListItem[]
  signedUp: boolean
} & Pick<SignedUpSignboard, 'signedUpStates'>

export type SignedUpBucketInfo = {
  id: number
  bucketKey: string
  bucketName: string
  bucketTopPageInfo: PageUrlInfo
  bucketGuidancePageUrl: string
  signedUp: boolean
} & Pick<SignedUpSignboard, 'signedUpStates'>

export class SignedUpBucketInfoDTO implements SignedUpBucketInfo {
  id: number
  bucketKey: string
  bucketName: string
  bucketTopPageInfo: PageUrlInfo
  bucketGuidancePageUrl: string
  signedUp: boolean
  signedUpStates: SignedUpState[]

  constructor(
    id: number,
    bucketKey: string,
    bucketName: string,
    bucketTopPageInfo: PageUrlInfo,
    bucketGuidancePageUrl: string,
    signedUp: boolean,
    signedUpStates: SignedUpState[],
  ) {
    this.id = id
    this.bucketKey = bucketKey
    this.bucketName = bucketName
    this.bucketTopPageInfo = bucketTopPageInfo
    this.bucketGuidancePageUrl = bucketGuidancePageUrl
    this.signedUp = signedUp
    this.signedUpStates = signedUpStates
  }

  static fromJSON(jsonObject: SignedUpBucketInfoJSON): SignedUpBucketInfoDTO {
    const filteredBucketTopPageUrl = ListUtility.findOne<UrlListItem>(
      jsonObject.urlList || [],
      item => item.type === 'bucketTopPageUrl',
    )
    const bucketTopPageInfo: PageUrlInfo = {
      url: filteredBucketTopPageUrl?.url,
      name: filteredBucketTopPageUrl?.name ?? '',
    }

    const filteredBucketGuidancePageUrl = ListUtility.findOne<UrlListItem>(
      jsonObject.urlList || [],
      item => item.type === 'bucketGuidancePageUrl',
    )
    const bucketGuidancePageUrl: Optional<string> = filteredBucketGuidancePageUrl?.url

    return new SignedUpBucketInfoDTO(
      jsonObject.id,
      jsonObject.bucketKey,
      jsonObject.bucketName,
      bucketTopPageInfo,
      bucketGuidancePageUrl || '',
      jsonObject.signedUp,
      jsonObject.signedUpStates,
    )
  }
}
